import { combineReducers } from 'redux';
import { User_list } from './users_list.reducers';
import { User_profile } from '../../../User_profile/redux/reducers/user_profile.reducers';
import { User_create } from '../../../User_create/redux/reducers/add_user.reducer';
import { Transport_user } from '../../../User_profile/redux/reducers/transport_user.reducers';
import { User_group } from '../../../User_group/redux/reducers/get_groups_list.reducers';
import { User_group_quantity } from '../../../User_group/redux/reducers/get_users_quantity.reducers';
import { User_group_create } from '../../../User_group_create/redux/reducers/add_group.reducers';
import { User_profile_phones_table } from '../../../User_profile/redux/reducers/user_profile_phones.reducers';
import { User_profile_emails_table } from '../../../User_profile/redux/reducers/user_profile_emails.reducers';
import { User_profile_address_table } from '../../../User_profile/redux/reducers/user_profile_address.reducers';
import { User_group_update } from '../../../User_group_update/redux/reducers/get_modules_structure.reducers';

export const UserManagement = combineReducers({
    User_list,
    User_profile,
    User_profile_phones_table,
    User_profile_emails_table,
    User_profile_address_table,
    User_create,
    Transport_user,
    User_group,
    User_group_quantity,
    User_group_create,
    User_group_update,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/reducers/index.js